import { useAppSelector } from "@redux/hooks";
import { selectTeacherProfileRetrieval } from "@user-management-context/read/application/use-cases/teacher/teacher-profile-retrieval/selectors/teacher-profile-selectors";
import { selectDocumentUpload } from "@shared-kernel/application/use-cases/document-upload/selectors/document-upload-selectors";
import { PayoutRequestDialog } from "./payout-request-dialog";

interface Props {
  parentDialogOnOpenChange: (open: boolean) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  hours: number;
  amount: number;
}

export const PayoutRequestDialogContainer = ({ open, onOpenChange, parentDialogOnOpenChange, hours, amount }: Props) => {
  const { data: profile } = useAppSelector(selectTeacherProfileRetrieval);
  const { processing } = useAppSelector(selectDocumentUpload);

  if (!profile) return null;

  return (
    <PayoutRequestDialog
      open={open}
      onOpenChange={onOpenChange}
      parentDialogOnOpenChange={parentDialogOnOpenChange}
      hours={hours}
      amount={amount}
      profile={profile}
      uploadProcessing={processing}
    />
  );
};
